module.exports = ".top-box-program-status-link {\r\n  cursor: pointer;\r\n}\r\n\r\n  .top-box-program-status-link:hover {\r\n    color: #4b80e0 !important;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tryout/components/tryout-past-due-members/tryout-past-due-members.component.css
// module id = ./src/app/tryout/components/tryout-past-due-members/tryout-past-due-members.component.css
// module chunks = main